module.exports = __webpack_public_path__ + "static/media/christinawelsh.59fcc878.png";


//////////////////
// WEBPACK FOOTER
// ./src/Scenes/HomePage/Components/Header/Components/Caption/christinawelsh.png
// module id = 330
// module chunks = 0